import {
  ClientOnboardingStatusType,
  LegalClientOnboardingStatusType,
  OnboardingProcessStepNameType,
} from 'api/types/entity';
import { isFinanceProject, isGlobalProject } from 'config';
import { lodash } from 'helpers';

const stepsWithStatuses = lodash.compact([
  {
    step: OnboardingProcessStepNameType.LegalClientSigningQuestionnaire,
    status: LegalClientOnboardingStatusType.SigningQuestionnaire,
  },
  isGlobalProject() && {
    step: OnboardingProcessStepNameType.LegalClientSigningServiceContract_Global,
    status: ClientOnboardingStatusType.SigningDocuments,
  },
  isFinanceProject() && {
    step: OnboardingProcessStepNameType.LegalClientSigningDocuments_Finance,
    status: ClientOnboardingStatusType.SigningDocuments,
  },
]);

export const useIsWaitingOnboardingStep = (
  stepName?: OnboardingProcessStepNameType,
  onboardingStatus?: LegalClientOnboardingStatusType
) => {
  const IsWaitingOnboardingStep = stepsWithStatuses.some(
    ({ status, step }) => stepName === step && onboardingStatus !== status
  );

  return IsWaitingOnboardingStep;
};
